import {Controller, useFormContext} from "react-hook-form";
import {Select} from "antd";
import {SessionCurrenciesDefaultCallCurrencyFormFieldType} from "../types";
import {FormFieldError} from "../../../../../../../../design-system/form-field";

export function SessionCurrencySelectFormField({
  currencyOptions,
}: {
  currencyOptions: string[];
}) {
  const {control} = useFormContext<SessionCurrenciesDefaultCallCurrencyFormFieldType>();

  return (
    <Controller
      control={control}
      name="callPriceCurrency"
      render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
        <div>
          <Select
            size="large"
            status={error?.message ? "error" : undefined}
            // style={{width: "100%"}}
            onChange={onChange}
            value={value}
            ref={ref}
            onBlur={onBlur}
            options={currencyOptions.map((c) => {
              return {
                value: c,
                label: c,
              };
            })}
            //   placeholder="Please select a duration"
          />
          <FormFieldError errorMessage={error?.message} />
        </div>
      )}
    />
  );
}
